<template>
  <div>

    <el-table :data="tableData" style="width: 800px" border>
      <el-table-column
        :prop="index"
        :label="item"
        sortable
        width="180"
        v-for="(item, index) in tableTitle"
        :key="item"
      >
      </el-table-column>
    </el-table>
    <div style="height: 100px"></div>
    <div class="chooseTable">
      <table
        border="1"
        style="border-collapse: collapse; border-color: #707070"
      >
        <tr>
          <th style="width: 100px">YES</th>
          <th style="width: 100px">NO</th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in chooseList" :key="index">
          <td>
            <div>
              <el-radio v-model="radio[index]" label="1"></el-radio>
            </div>
          </td>
          <td>
            <div>
              <el-radio v-model="radio[index]" label="0"></el-radio>
            </div>
          </td>
          <td>
            {{ item }}
          </td>
        </tr>
      </table>
    </div>
    <div style="height: 100px"></div>
    <div class="xCheckbox">
      <table
        border="1"
        style="border-collapse: collapse; border-color: #707070"
      >
        <tr>
          <th style="width: 100px"></th>
          <th
            style="width: 200px"
            v-for="(item, index) in questionList"
            :key="index"
          >
            {{ item }}
          </th>
          <th></th>
        </tr>
        <tr v-for="(item, index) in checkList" :key="index">
          <td style="text-align: center">{{ englishList[index] }}</td>
          <td v-for="(z, i) in questionList" :key="i">
            <div>
              <el-radio
                v-model="checkRadio[i]"
                :label="englishList[index]"
              ></el-radio>
            </div>
          </td>
          <td>
            {{ item }}
          </td>
        </tr>
      </table>
    </div>
    <div style="height: 100px"></div>
    <el-tabs v-model="activeName" type="card" style="width: 800px">
      <el-tab-pane label="用户管理" name="first"
        ><el-table :data="tableData" style="width: 800px" border>
          <el-table-column
            :prop="index"
            :label="item"
            sortable
            width="180"
            v-for="(item, index) in tableTitle"
            :key="item"
          >
          </el-table-column> </el-table
      ></el-tab-pane>
      <el-tab-pane label="配置管理" name="second">配置管理</el-tab-pane>
      <el-tab-pane label="角色管理" name="third">角色管理</el-tab-pane>
      <el-tab-pane label="定时任务补偿" name="fourth">定时任务补偿</el-tab-pane>
    </el-tabs>
    <div style="height: 100px"></div>
    <div class="singleBox">
      <table
        border="1"
        style="border-collapse: collapse; border-color: #707070"
      >
        <tr v-for="(item, index) in singleChoice" :key="index">
          <td style="width: 100px">
            <div>
              <el-radio v-model="single" :label="index"></el-radio>
            </div>
          </td>
          <td>
            {{ item }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: "first",
      tableData: [
        {
          date: "2016-05-02",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1518 弄",
        },
        {
          date: "2016-05-04",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1517 弄",
        },
        {
          date: "2016-05-01",
          name: "王小虎",
          address: "上海市普陀区金沙江路 1519 弄",
        },
        {
          date: "2016-05-03",
          name: "王小虎",
          address: "222",
        },
      ],
      tableTitle: {
        date: "日期",
        name: "姓名",
        address: "地址",
      },
      chooseList: [
        "A. The median amount of protein for all uncooked vegetable listed is 1/3 themedian amount of protein for all cooked vegetables listed.",
        "B. The amount of carbohydrate per serving of cooked corn is exactly 3 times themedian amount of carbohydrate per serving for the other 14 vegetable optionslisted.",
        "C. Each serving listed for which total fiber is less than 3.0g also has at most 10g of carbohydrate.",
      ],
      checkList: [2, 4, 6, 8, 10, 12],
      questionList: ["Rounds completed", "Teams remaining"],
      checkRadio: [],
      radio: [],
      englishList: [
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
      ],
      singleChoice: [
        "A. help explain why investor sentiment toward some firms is sometimes very low",
        "B. caution that some variables should not be considered accurate predictors ofIPOpricing",
        "B. caution that some variables should not be considered accurate predictors ofIPOpricing",
        "B. caution that some variables should not be considered accurate predictors ofIPOpricing",
        "B. caution that some variables should not be considered accurate predictors ofIPOpricing",
        "B. caution that some variables should not be considered accurate predictors ofIPOpricing",
      ],
      single: "",
    };
  },
  methods: {},
  mounted() {
    this.chooseList.forEach((item) => {
      this.radio.push("");
    });
    this.questionList.forEach((item) => {
      this.checkRadio.push("");
    });
  },
};
</script>

<style scoped>
.chooseTable tr > td:last-child {
  width: 600px;
  padding: 5px 10px;
  line-height: 1.5;
  box-sizing: border-box;

}
.chooseTable tr > td:first-child div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.chooseTable tr > td:nth-child(2) div {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .chooseTable .el-radio__label {
  display: none;
}
.xCheckbox tr > td:last-child {
  width: 300px;
  padding: 5px 10px;
  line-height: 1.5;
  text-align: center;
  box-sizing: border-box;

}
.xCheckbox tr > td:nth-child(2) div,
.xCheckbox tr > td:nth-child(3) div {
  display: flex;
  align-items: center;
  justify-content: center;
}
/deep/ .xCheckbox .el-radio__label {
  display: none;
}

/deep/ .singleBox .el-radio__label {
  display: none;
}

.singleBox tr > td:first-child div {
  display: flex;
  align-items: center;
  justify-content: center;
}
.singleBox tr > td:last-child{
    width: 700px;
  padding: 5px 10px;
  line-height: 1.5;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/view/test/test.vue